module.exports = __webpack_public_path__ + "img/logo_pri-myte.712443a5.png";